import React from 'react';
import { Space } from 'antd';
import './PageLayout.css';

export function PageContainer({ children, className = '', style }) {
  return (
    <div className={`oa-page ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}

export function PageTitle({ children }) {
  return <h2 className="oa-page-title">{children}</h2>;
}

/** 筛选区与主操作按钮同一行：左侧 filters，右侧 actions */
export function PageToolbar({ filters, actions }) {
  if (!filters && !actions) return null;
  return (
    <div className="oa-page-toolbar">
      {filters ? (
        <Space wrap size="middle" className="oa-page-toolbar__filters">
          {filters}
        </Space>
      ) : (
        <span className="oa-page-toolbar__filters" />
      )}
      {actions ? (
        <Space wrap className="oa-page-toolbar__actions">
          {actions}
        </Space>
      ) : null}
    </div>
  );
}

export { default as DataTable, createPaginationState, DEFAULT_PAGE_SIZE } from '../DataTable';

export default PageContainer;
